export interface UiModel {
  isUnsavedChangesModalNeeded: boolean;
  unsavedChangesMessage: string;
  unsavedChangesAcceptLabel: string;
  unsavedChangesRejectLabel: string;
  unsavedChangesAreaId: UiArea;
}

export enum UnsavedChangesModalType {
  none = 0,
  stayOrContinue = 1,
}

export enum UiArea {
  none = 0,
  pipelineUploadDocs = 1,
}

export function createInitialUiState(): UiModel {
  return <UiModel>{
    isUnsavedChangesModalNeeded: true,
    unsavedChangesMessage: '',
    unsavedChangesAcceptLabel: '',
    unsavedChangesRejectLabel: '',
    unsavedChangesAreaId: UiArea.none,
  };
}
